import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {QuoteTemplatePage} from '../../../ui/setup/sales-documents/quotes/quote-template-page';

export function QuoteTemplatePageStandalone() {
    setBodyId('quote-template');

    return (
        <PageContainer
            noPadding={true}
            title='Quote Template'
            whiteBackground={true}
            pageTitleBar={
                <PageTitleBar
                    title='Quote template'
                    subheaderPrimaryText='Set up your default information for faster and efficient quotes.'
                />
            }
        >
            <QuoteTemplatePage />
        </PageContainer>
    );
}
